

import HeroBanner from "../../components/HeroBanner";
import Steps from "../../components/Steps";
import {usePrismicDocumentsByTag} from '@prismicio/react';

export default function KazakhstanProgram()  {

    const [kazakhstan] = usePrismicDocumentsByTag("kazakhstan");

    return (
        <main>
            {kazakhstan && (
                <div className="program-container">
                    <HeroBanner
                        id="kazakhstan-program"
                        heading={kazakhstan.results[0].data.hero_title[0].text}>
                    </HeroBanner>
                    <Steps
                        image={kazakhstan.results[0].data['list-image'].url}
                        paragraph={kazakhstan.results[0].data.paragraph[0].text}
                        heading={kazakhstan.results[0].data.heading[0].text}
                        steps={kazakhstan.results[0].data.step_list || []}
                    />

                    <section>
                        <div className="container">
                            <div className="section-title">
                                <h2>{kazakhstan.results[0].data.families_number[0].text}</h2>
                            </div>
                        </div>
                    </section>
                </div>
            )}
        </main>
    )

}